import { createFileRoute } from '@tanstack/react-router';
import BookmarkListPage from '../components/BookmarkListPage';
import { useUserPreferences } from '../hooks/useUserPreferences';
import { useVideoBookmarks } from '../services/dataHooks';

export const Route = createFileRoute('/_app/videos/read/$id')({
  component: VideosReadPage,
});

function VideosReadPage() {
  const { preferences } = useUserPreferences();
  const { bookmarks, isLoading: isBookmarkCollectionLoading } = useVideoBookmarks();

  return (
    <BookmarkListPage
      mode="videos"
      bookmarks={bookmarks}
      condensedView={preferences.bookmarkList.view === 'condensed'}
      showThumbnails={preferences.bookmarkList.thumbnails}
      isLoading={isBookmarkCollectionLoading}
    />
  );
}
